import React, { useMemo, useState } from 'react';
import { Icon, ListItemText, Tooltip } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import AppBadge from '@crema/core/AppBadge';
import AppNavLink from '@crema/core/AppNavLink';
import Box from '@mui/material/Box';
import { checkPermission } from '../../../../utility/helper/RouteHelper';
import { useAuthUser } from '../../../../utility/AuthHooks';
import VerticalNavItem from './VerticalItem/VerticalNavItem';
import ModalInformasi from '../ModalInformasi';
import * as icon from '@mui/icons-material';

const checkAccess = (userRoles, menuRoles) => {
    let permit = false;
    for (const value of menuRoles) {
        if (userRoles.includes(value)) {
            permit = true;
            break;
        }
    }
    return permit;
};

const VerticalModal = ({ level, item }) => {
    const { user } = useAuthUser();
    const [open, setOpen] = useState(false);
    const hasPermission = useMemo(
        () => checkPermission(item.permittedRole, user.role),
        [item.permittedRole, user.role],
    );
    if (!hasPermission) {
        return null;
    }

    if (item.role_access) {
        const roleAccess = checkAccess(user.roles_access, item.role_access);
        if (!roleAccess) return null;
    }

    const handleClick = (state) => {
        setOpen(state)
    };

    let toProps = {
    }

    const IconComponent = icon[item?.icon];

    return (
        <>
            <VerticalNavItem
                level={level}
                button
                component={AppNavLink}
                activeClassName={item.isNewWindow === '1' || item.isAction === '1' ? '' : ''}
                exact={item.exact}
                onClick={() => handleClick(true)}
                {...toProps}
            >
                {item.icon && (
                    <Box component='span' sx={{ width: 30, height: 30, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 3 }}>
                        <Icon
                            color='action' className={clsx('nav-item-icon')}
                            sx={{
                                fontSize: { xs: 16, xl: 18 },
                            }}
                        >
                            <IconComponent sx={{ fontSize: '20px' }} />
                        </Icon>
                    </Box>
                )}
                {
                    item.tooltip &&
                    <Tooltip title={item.tooltip} placement='top' arrow>
                        <ListItemText
                            className='nav-item-content'
                            primary={item.messageId}
                            classes={{ primary: 'nav-item-text' }}
                            style={{ wordWrap: 'break-word !important', whiteSpace: 'pre-wrap !important' }}
                        />
                    </Tooltip>
                }
                {
                    !item.tooltip &&
                    <ListItemText
                        className='nav-item-content'
                        primary={item.messageId}
                        classes={{ primary: 'nav-item-text' }}
                        sx={{ wordWrap: 'break-word !important', whiteSpace: 'pre-wrap !important' }}
                    />
                }

                {item.count && (
                    <Box sx={{ mr: 3.5 }} className='menu-badge'>
                        <AppBadge count={item.count} color={item.color} />
                    </Box>
                )}
            </VerticalNavItem>

            <ModalInformasi
                open={open}
                handleClose={handleClick}
            />
        </>
    );
};

VerticalModal.propTypes = {
    item: PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.string,
        icon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
        permittedRole: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
        exact: PropTypes.bool,
        messageId: PropTypes.string,
        count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        url: PropTypes.string,
        color: PropTypes.string,
        isNewWindow: PropTypes.any,
        isAction: PropTypes.any,
        role_access: PropTypes.any,
        tooltip: PropTypes.string
    }),
    level: PropTypes.number,
};

VerticalModal.defaultProps = {};

export default React.memo(VerticalModal);
